
<div class="label-line">
  <label [id]="labelId" [for]="controlId">
    <ng-content select="kb-label" />
  </label>
  <kb-control-hint #hintElement [showError]="showError">
    <ng-content select="kb-hint" ngProjectAs="kb-hint" />
    <ng-content select="kb-error" ngProjectAs="kb-error" />
  </kb-control-hint>
</div>
<ng-content />
